import React, { useEffect, useState } from "react";
import logo from '../../../assets/msw-logo.png';
import axios from "../../../api/axios";
import { useQuery } from "@tanstack/react-query";

const Approved = () => {
    const search = window.location.search;
    const param = new URLSearchParams(search);
    const token = param.get('token');

    const [message, setMessage] = useState(null);

    const { data: approvedTimesheet, isLoading, error } = useQuery({
        queryKey: ['timesheetApproval'],
        queryFn: async () => {
            const res = await axios.patch('dtr/timesheets', { status: 1 }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            return res.data.response;
        },
        enabled: !!token,
        staleTime: Infinity,
        retry: false
    });

    useEffect(() => {
        if (error) {
            setMessage(error.response?.data.response || 'Something went wrong while approving submitted DTR!');
        } else if (approvedTimesheet) {
            setMessage(approvedTimesheet);
        }
    }, [error, approvedTimesheet]);

    return (
        <div className="approval-disapproval approved">
            <div className='icon'>
                <i className={`fa ${isLoading ? 'fa-spinner fa-spin' : (error ? 'fa-exclamation-triangle' : 'fa-check-circle')}`}></i>
            </div>
            <p className='message'>
                {isLoading ? 'Loading...' : message}
            </p>
            <div className='ad-footer'>
                <div className='logo'>
                    <img src={logo} alt='Logo' />
                </div>
                <p>&copy; Megasportsworld 2025.</p>
            </div>
        </div>
    );
};

export default Approved;
